import MessageIcon from '@material-ui/icons/ViewList';

import MessageList from './ParkingVehicleBatchList';
import MessageCreate from './ParkingVehicleBatchCreate';
import MessageEdit from './ParkingVehicleBatchEdit';

export default {
    list: MessageList,
    create: MessageCreate,
    edit: MessageEdit,
    icon: MessageIcon,
};
